import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {UserAdProfile} from "../models/user-ad-profile.model";

@Injectable()
export class UserAdProfileService {

    private profileApiUrl: string = `${environment.microsoftGraphApi}/me`;

    constructor(private http: HttpClient) {
    }

    async getProfile(accessToken: string): Promise<UserAdProfile> {
        const headers: HttpHeaders = new HttpHeaders({
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });
        return this.http.get(this.profileApiUrl, {headers: headers}).toPromise();
    }

}



// WEBPACK FOOTER //
// ./src/app/services/user-ad-profile.service.ts